// Executive insights "What changed" (approved HTML component: executive-insights).
import type { ReactNode } from 'react';

export interface ExecutiveInsightsProps {
  rows: Array<{ label: string; value: string; fresh: boolean }>;
}

export function ExecutiveInsights({ rows }: ExecutiveInsightsProps): ReactNode {
  return (
    <section className="exec-card" data-component="executive-insights">
      <div className="exec-head">
        <h2>What changed</h2>
        <small>Compared with prior period</small>
      </div>
      <div className="exec-body source-list">
        {rows.map(row => (
          <div key={row.label}>
            <span>{row.label}</span>
            <strong className={row.fresh ? 'fresh' : ''}>{row.value}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
